function ShippingPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Delivery Policy</h1>

        <section>
          <h2>Delivery Time</h2>
          <p>Orders are delivered within 30–60 minutes depending on location.</p>
        </section>

        <section>
          <h2>Delivery Charges</h2>
          <p>Delivery fees vary based on distance.</p>
        </section>

        <section>
          <h2>Service Areas</h2>
          <p>We currently operate in selected cities across India.</p>
        </section>
      </div>
    </div>
  );
}

export default ShippingPolicy;
